
import { IMapLink } from './IMapLink';

const MapLink = ({ latitude, longitude, label }: IMapLink) => {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const mapsUrl = isMobile ? `geo:${latitude},${longitude}?q=${latitude},${longitude}(${encodeURIComponent(label!)})`
        : `https://www.google.com/maps?q=${latitude},${longitude}&q=${encodeURIComponent(label!)}`;

    return (
        <a style={{ fontSize: "0.85rem", textDecoration: "underline" }} href={mapsUrl} rel="noopener noreferrer" target={isMobile ? undefined : "_blank"}>
            مسیریابی روی نقشه
        </a>
    );
};

export default MapLink;